import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Paths from '../../../config/routes';
import {
  Home,
  NotFound,
  Auth,
  Supervisor,
  TestPage,
  Login,
  Applications,
  DoubleFactor,
} from '../../pages';
import AgentRoute from './agent-route';
import PrivateRoute from './private-route';
import SupervisorRoute from './supervisor-route';

// eslint-disable-next-line no-undef
const isDevEnv = process.env.NODE_ENV === 'development';

const Routes = () => (
  <Router>
    <Switch>
      {isDevEnv && <Route component={TestPage} exact path={Paths.TEST} />}
      <Route exact path={Paths.LOGIN} render={Login} />
      <Route exact path={Paths.DOUBLE_FACTOR_FORM} render={DoubleFactor} />
      <SupervisorRoute component={Supervisor} path={Paths.SUPERVISOR} />
      <AgentRoute component={Home} exact path={Paths.AGENT} />
      <AgentRoute component={Home} exact path={Paths.AUDITOR} />
      <PrivateRoute component={Applications} exact path={Paths.APPLICATIONS} />
      <Route component={Auth} exact path={Paths.AUTH} />
      <Route component={NotFound} exact path={Paths.ERROR} />
      <AgentRoute component={Home} exact path={Paths.CONVERSATION} />
      <AgentRoute component={Home} exact path={Paths.STATS} />
      <Route path="*" render={() => <NotFound noMatch />} />
    </Switch>
  </Router>
);

export default Routes;
